import React, { useEffect, useState } from 'react';
import { useStyles } from './index.style';
import { Form, Alert, Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';
import { MButton, MForm } from 'ui-component/antdStyle';
import { SET_PAYMENT } from 'store/userReducer';
import { useAppDispatch } from 'store/hook';
import Tips from 'ui-component/Tools/Tips';
import Captcha from 'ui-component/captcha';
import { Email, NumberCode } from 'constants/regexp';
import { MModal } from 'ui-component';
import { checkPaymentPassword, getUserDetail } from 'controller/auth';

interface IHookProps {
  open: boolean;
}

const CMP: React.FC<IHookProps> = ({ open }) => {
  const { styles, cx } = useStyles();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['common']);
  const [loading, setLoading] = useState<boolean>(false);
  const [verifyCodeError, setVerifyCodeError] = useState<boolean>(false);
  const [verifyCode, setVerifyCode] = useState<string | null>(null);
  const [form] = Form.useForm();
  const [rememberMe, setRememberMe] = useState<boolean>(false);

  const onClose = () => {
    dispatch(
      SET_PAYMENT({
        openConfirmPayment: false
      })
    );
  };

  const onSubmit = async () => {
    if (!verifyCode || !NumberCode.test(verifyCode)) {
      setVerifyCodeError(true);
      return;
    }
    setLoading(true);
    const res = await checkPaymentPassword({
      pin: verifyCode,
      rememberMe: rememberMe
    });
    setLoading(false);
    if (res.success) {
      if (res.data?.status === 'PASS') {
        onClose();
        Tips(`success`, t('verify', { ns: 'common' }));
        return;
      } else if (res.data?.status === 'FROZEN') {
        onClose();
        getUserDetail();
        Tips(`error`, t('forzenAccount', { ns: 'common' }));
        return;
      } else if (res.data?.status === 'FAILED') {
        Tips(`error`, `${t('forzenTime', { ns: 'common', time: 10 - res.data.failedTryTimes })}`);
        return;
      }
    }
  };

  const onComplete = (e: any) => {
    setVerifyCodeError(false);
    setVerifyCode(e);
  };

  return (
    <MModal open={open} title={t('verifyPayPassword', { ns: 'common' })} onCancel={onClose} width={460} loading={loading} hiddenFooter>
      <div className={styles.container}>
        <MForm layout="vertical" form={form}>
          <Alert message={t('verifyPayPasswordDesc', { ns: 'common' })} type="error" className={styles.alert} />
          <Captcha
            error={verifyCodeError}
            onComplete={onComplete}
            type="password"
            title={t('paymentPassword', { ns: 'common' })}
            required
            className={styles.verifyBox}
          />
          <Form.Item label="" name="rememberMe" valuePropName="checked">
            <Checkbox checked={rememberMe} onChange={() => setRememberMe(!rememberMe)}>
              {t('noLogin4', { ns: 'common' })}
            </Checkbox>
          </Form.Item>
          <div className={styles.footer}>
            <MButton type="primary" className={styles.btn} size="large" onClick={onSubmit}>
              {t('confirm', { ns: 'common' })}
            </MButton>
          </div>
        </MForm>
      </div>
    </MModal>
  );
};

export default CMP;
